export const TREE_PUB = {
    pubProps: {
        data: {type: [Object, Array]},
        labelKey: {type: String, require: true},
        childrenKey: {type: String, require: true},
        collapseOnClickNode: {type: Boolean, default: true},
        levelSpace: {type: Number, default: 12},
        nodeClass: {type: [String, Function]},
    },
}
